import {
  AccredibleLanguageServiceModule,
  CUSTOM_DATE_FORMATS,
  CustomDatePickerAdapter,
} from '@accredible-frontend-v2/services/language';
import { provideHttpClient } from '@angular/common/http';
import { ApplicationConfig } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, Routes, withInMemoryScrolling } from '@angular/router';
import { ShellComponent } from '@directory-of-directories/feature-layout';

const routes: Routes = [
  {
    path: '',
    component: ShellComponent,
    children: [
      {
        path: '',
        redirectTo: '',
        pathMatch: 'full',
      },
      {
        path: '',
        loadChildren: () =>
          import('@directory-of-directories/feature-list').then(
            (m) => m.DirectoryOfDirectoriesListRoutes,
          ),
      },
    ],
  },
];

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
      }),
    ),
    provideHttpClient(),
    provideAnimations(),
    ...AccredibleLanguageServiceModule.forRoot(['en']).providers,
    { provide: DateAdapter, useClass: CustomDatePickerAdapter },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
  ],
};
